import { Card, FormField, InputWidth, ReadOnlyField } from '@msaf/core-react'
import { WellEndPointFields } from '../../../../types/form-types'
import LocationFieldView from '../../wells/location-field-view'

interface WellEndPointViewInterface {
  fields: Partial<WellEndPointFields>
  index: number
  isLoading: boolean
}

export default function WellEndPointView({ fields, index, isLoading }: WellEndPointViewInterface) {
  return (
    <Card>
      <LocationFieldView
        isMapHidden
        index={index}
        isLoading={isLoading}
        formFieldLabel={`End Point ${index + 1}`}
        easting={{
          labelId: 'easting',
          value: `${fields.easting ?? ''}`,
        }}
        northing={{
          labelId: 'Northing',
          value: `${fields.northing ?? ''}`,
        }}
        latitude={{
          labelId: 'Latitude',
          value: `${fields.latitude ?? ''}`,
        }}
        longitude={{
          labelId: 'Longitude',
          value: `${fields.longitude ?? ''}`,
        }}
      />
      <FormField isSkeleton={isLoading} label='Elevation (m)' labelId='elevation'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='elevation'
          value={`${fields['elevation'] ?? ''}`}
        />
      </FormField>
    </Card>
  )
}
